import { Controller } from "@hotwired/stimulus";
import { headers } from "../utils";

// Connects to data-controller="budget"
export default class extends Controller {
  static targets = ["checkbox", "item"];

  connect() {
    console.log("budget#connect");
    this.activated = false;
  }

  toggle(ev) {
    const activated = document.body.dataset.app == "budget_calculator";
    if (!activated) return;

    ev.preventDefault();
    ev.stopPropagation();

    ev.currentTarget.classList.toggle("included");
    const included = ev.currentTarget.classList.contains("included");
    const body = {
      idea: {
        include_in_list: included,
      },
    };

    console.log(ev.params.url, headers(), body);

    Turbo.fetch(ev.params.url, {
      method: "PUT",
      headers: headers(),
      body: JSON.stringify(body),
    }).then((resp) => {
      if (!resp.ok) {
        return resp.text().then((html) => {
          Turbo.renderStreamMessage(html);
        });
      } else {
        resp.text().then((html) => {
          Turbo.renderStreamMessage(html);
        });
      }
    });
  }
}
